import React, { Component } from 'react';
import { Button } from 'reactstrap';
import intl from 'react-intl-universal';
import Axios from '../../config/Axios';
import './styles/monitoringNotificationPreferences.scss';

const oDefaults = {
  criticalAlerts: true,
  absenceAlerts: true,
  calibrationAlerts: true,
  absenceFrequency: 'daily'
};

class MonitoringNotificationPreferences extends Component {
  state = {
    bLoading: true,
    bCanView: false,
    bSaving: false,
    bSaved: false,
    cError: '',
    oPreferences: oDefaults
  };

  componentDidMount() {
    Axios.get('monitoring/notification-preferences')
      .then(oResponse => {
        const oData = oResponse.data && oResponse.data.data;
        this.setState({
          bLoading: false,
          bCanView: true,
          oPreferences: { ...oDefaults, ...(oData || {}) }
        });
      })
      .catch(oError => {
        const nStatus = oError.response && oError.response.status;
        this.setState({
          bLoading: false,
          bCanView: nStatus !== 403,
          cError: nStatus === 403
            ? ''
            : intl.get('Monitoring.notification_preferences.load_error')
        });
      });
  }

  handleChange = oEvent => {
    const { name, type, checked, value } = oEvent.target;
    this.setState({
      bSaved: false,
      oPreferences: {
        ...this.state.oPreferences,
        [name]: type === 'checkbox' ? checked : value
      }
    });
  };

  handleSave = () => {
    this.setState({ bSaving: true, bSaved: false, cError: '' });
    Axios.put('monitoring/notification-preferences', this.state.oPreferences)
      .then(() => this.setState({ bSaving: false, bSaved: true }))
      .catch(oError => this.setState({
        bSaving: false,
        cError: (oError.response && oError.response.data && oError.response.data.cMessage)
          || intl.get('Monitoring.notification_preferences.save_error')
      }));
  };

  render() {
    const {
      bLoading, bCanView, bSaving, bSaved, cError, oPreferences
    } = this.state;

    if (bLoading || !bCanView) return null;

    return (
      <fieldset className="monitoring-notification-preferences">
        <div className="customer-head">
          <legend>{intl.get('Monitoring.notification_preferences.title')}</legend>
        </div>
        <p className="monitoring-notification-preferences__description">
          {intl.get('Monitoring.notification_preferences.description')}
        </p>
        <label className="monitoring-notification-preferences__checkbox">
          <input
            type="checkbox"
            name="criticalAlerts"
            checked={oPreferences.criticalAlerts}
            onChange={this.handleChange}
          />
          {intl.get('Monitoring.notification_preferences.critical_alerts')}
        </label>
        <label className="monitoring-notification-preferences__checkbox">
          <input
            type="checkbox"
            name="absenceAlerts"
            checked={oPreferences.absenceAlerts}
            onChange={this.handleChange}
          />
          {intl.get('Monitoring.notification_preferences.absence_alerts')}
        </label>
        <label className="monitoring-notification-preferences__checkbox">
          <input
            type="checkbox"
            name="calibrationAlerts"
            checked={oPreferences.calibrationAlerts}
            onChange={this.handleChange}
          />
          {intl.get('Monitoring.notification_preferences.calibration_alerts')}
        </label>
        <label className="monitoring-notification-preferences__field">
          {intl.get('Monitoring.notification_preferences.absence_frequency')}
          <select
            name="absenceFrequency"
            value={oPreferences.absenceFrequency}
            onChange={this.handleChange}
          >
            <option value="daily">
              {intl.get('Monitoring.notification_preferences.frequency_daily')}
            </option>
            <option value="immediate">
              {intl.get('Monitoring.notification_preferences.frequency_immediate')}
            </option>
          </select>
        </label>
        {cError && <p className="monitoring-notification-preferences__error" role="alert">{cError}</p>}
        {bSaved && (
          <p className="monitoring-notification-preferences__success" role="status">
            {intl.get('Monitoring.notification_preferences.save_success')}
          </p>
        )}
        <Button type="button" onClick={this.handleSave} disabled={bSaving}>
          {bSaving ? intl.get('carregando') : intl.get('salvar')}
        </Button>
      </fieldset>
    );
  }
}

export default MonitoringNotificationPreferences;
